let treeChildren = (index, data, Vue) => {
  var arr = [];
  if (data) {
    for (let i = 1; i < 12; i++) {
      let obj = {};
      let ball = ('0' + i).slice(-2);
      // console.log('ball', ball)
      obj.title = `${ball}`;
      obj.align = 'center';

      var n = 0;

      obj.className = `tree_table_children_${index}`;
      obj.render = (h, row) => {
        if (row.row.ball_json.numSpread.nums[ball] == 0) {
          var num = row.row.ballList[n % 5];
          n += 1;
          return <span class="red">{num}</span>;
        } else if (Vue.divideList[ball] > row.index) {
          return <span class="divide_lost_info lost_info">{row.row.ball_json.numSpread.nums[ball]}</span>;
        } else {
          return <span class="lost_info">{row.row.ball_json.numSpread.nums[ball]}</span>;
        }
      };
      arr.push(obj);
    }
    return arr;
  }
};
var lostTreeChildren = (index, data) => {
  var arr = [];
  if (data) {
    for (let i = 1; i < 12; i++) {
      var obj = {};
      let ball = ('0' + i).slice(-2);
      obj.title = `${ball}`;
      // obj.title = `${i}`;
      obj.align = 'center';
      // obj.width = '37';
      obj.className = `tree_table_children_${index}`;
      obj.render = (h, row) => {
        var name = `ball${index + 1}`;
        var key = row.row.key;
        var n = row.row.lost.ballJson[name].nums[ball];
        if (key != 'averageOmit') {
          return <span>{n[key] ? n[key] : 0}</span>;
        }
      };
      arr.push(obj);
    }
    return arr;
  }
};
let xingtaiChildren = data => {
  let arr = [];
  let shape = ['和值', '大', '小', '和', '单', '双', '和', '尾大', '尾小'];
  let str = ['sum', 'big', 'small', 'flat', 'single', 'double', 'flat', 'big', 'small'];
  if (data) {
    for (let i = 0; i < shape.length; i++) {
      let obj = {};
      obj.title = `${shape[i]}`;
      obj.align = 'center';
      obj.className = `join_table_children`;
      obj.render = (h, row) => {
        if (i == 0) {
          return <span>{row.row.sum_json.sum}</span>;
        } else if (0 < i && i <= 3) {
          let divideList = data[0].sum_json.bigSmall[str[i]];
          var n = row.row.sum_json.bigSmall[str[i]];
          if (n == 0) {
            return <span class={`table_join_${i % 2}`}>{shape[i]}</span>;
          } else if (divideList > row.index) {
            return <span class="divide_lost_info lost_info">{n}</span>;
          } else {
            return <span class="lost_info">{n}</span>;
          }
        } else if (3 < i && i <= 6) {
          let divideList = data[0].sum_json.singleDouble[str[i]];
          let n = row.row.sum_json.singleDouble[str[i]];
          if (row.row.sum_json.singleDouble[str[i]] == 0) {
            return <span class={`table_join_${i % 2}`}>{shape[i]}</span>;
          } else if (divideList > row.index) {
            return <span class="divide_lost_info lost_info">{n}</span>;
          } else {
            return <span class="lost_info">{n}</span>;
          }
        } else if (i > 6) {
          var divideList = data[0].sum_json.tailBigSmall[str[i]];
          var n = row.row.sum_json.tailBigSmall[str[i]];
          if (row.row.sum_json.tailBigSmall[str[i]] == 0) {
            return <span class={`table_join_${i % 2}`}>{shape[i]}</span>;
          } else if (divideList > row.index) {
            return <span class="divide_lost_info lost_info">{n}</span>;
          } else {
            return <span class="lost_info">{n}</span>;
          }
        }
      };
      arr.push(obj);
    }
    return arr;
  }
};

var lostXtChildren = (data, index) => {
  var arr = [];
  var shape = ['和值', '大', '小', '和', '单', '双', '和', '尾大', '尾小'];
  var str = ['sum', 'big', 'small', 'flat', 'single', 'double', 'flat', 'big', 'small'];
  if (data) {
    for (let i = 0; i < shape.length; i++) {
      var obj = {};
      obj.title = `${shape[i]}`;
      obj.align = 'center';
      // obj.width = '37';
      obj.className = `join_table_children`;
      obj.render = (h, row) => {
        var name = `ball${index + 1}`;
        var key = row.row.key;
        var n = row.row.lost.sumJson;
        if (i == 0) {
          return <span>0</span>;
        }
        if (0 < i && i <= 3) {
          return <span>{n.bigSmall[str[i]][key]}</span>;
        } else if (3 < i && i < 7) {
          return <span>{n.singleDouble[str[i]][key]}</span>;
        } else if (i > 6) {
          return <span>{n.tailBigSmall[str[i]][key]}</span>;
        }
      };
      arr.push(obj);
    }
    return arr;
  }
};

const choose5 = (data, ballindex) => {
  let list = Vue => {
    let arr = [
      {
        title: '期数',
        align: 'center',
        key: 'issue_id',
        className: `table_issueId`,
        width: 170
      },
      {
        title: '开奖号码',
        align: 'center',
        width: 150,
        className: `table_issueId`,
        render: (h, { row }) => {
          let ball = row.balls.split(',')
          return (
            <div class="pk_balls">
              {ball.map((x, i) => {
                return (
                  <span class={'ball_red'} key={i}>
                    {x}
                  </span>
                );
              })}
            </div>
          );
        }
      },
      {
        title: `号码分布`,
        align: 'center',
        className: `table_issueId`,
        children: treeChildren(ballindex, data, Vue)
      },
      {
        title: '总分',
        align: 'center',
        className: `table_issueId`,
        children: xingtaiChildren(data)
      }
    ];
    return arr;
  };
  let lostList = Vue => {
    let arr = [
      {
        title: '数据统计',
        align: 'center',
        key: 'name',
        className: `table_issueId`,
        width: 320
      },
      {
        title: `号码分布`,
        align: 'center',
        className: `table_issueId`,
        children: lostTreeChildren(ballindex, data)
      },
      {
        title: '总分',
        align: 'center',
        className: `table_issueId`,
        children: lostXtChildren(data, ballindex)
      }
    ];
    return arr;
  };
  return { list, lostList };
};

export default choose5;



// WEBPACK FOOTER //
// ./src/pages/Trend/Haomafenbu/columns/choose5.js